import React, { useState, useEffect, Suspense, lazy } from 'react';
import { AxiosInstance } from './Components/baseUrl';
import AuthComponent from './Components/Auth/AuthComponent';
import Sidebar from './Components/Navigation/Sidebar';
import CalendarView from './Components/Calendar/CalendarView';
import SalaryPage from './Components/Salary/SalaryPage';
import ExpensesPage from './Components/Expenses/ExpensesPage';
import Spinner from './Components/Spinners/Spinner';

// ВікіStats — окрема «вкладка» лише для адміна, вантажиться окремим чанком
const WikiStatsApp = lazy(() => import('./Components/WikiStats/WikiStatsApp'));

const isWikiHash = () => window.location.hash.startsWith('#/wiki');

function App() {
    const [isAuth,       setIsAuth]       = useState(false);
    const [checking,     setChecking]     = useState(true);
    const [page,         setPage]         = useState('calendar');
    const [currentUser,  setCurrentUser]  = useState(null);
    const [wikiOpen,     setWikiOpen]     = useState(isWikiHash);

    useEffect(() => {
        const onHash = () => setWikiOpen(isWikiHash());
        window.addEventListener('hashchange', onHash);
        return () => window.removeEventListener('hashchange', onHash);
    }, []);

    const openWiki = () => { window.location.hash = '#/wiki'; };
    const closeWiki = () => {
        window.history.pushState('', document.title, window.location.pathname + window.location.search);
        setWikiOpen(false);
    };

    useEffect(() => {
        AxiosInstance.get('/auth/check')
            .then(r => { setIsAuth(true); setCurrentUser(r.data); })
            .catch(() => setIsAuth(false))
            .finally(() => setChecking(false));
    }, []);

    const handleLogout = async () => {
        await AxiosInstance.post('/auth/logout');
        setIsAuth(false);
        setCurrentUser(null);
    };

    if (checking) return <Spinner />;

    if (!isAuth) return <AuthComponent onLogin={(user) => { setIsAuth(true); setCurrentUser(user); }} />;

    if (wikiOpen && currentUser?.is_admin) {
        return (
            <Suspense fallback={<Spinner />}>
                <WikiStatsApp currentUser={currentUser} onExit={closeWiki} />
            </Suspense>
        );
    }

    return (
        <div className="app-layout">
            <Sidebar page={page} setPage={setPage} onLogout={handleLogout} currentUser={currentUser} onOpenWiki={openWiki} />
            <div className="main-content">
                {page === 'calendar'  && <CalendarView />}
                {page === 'salary'   && <SalaryPage />}
                {page === 'expenses' && <ExpensesPage />}
            </div>
        </div>
    );
}

export default App;
